import api from '../api';

const controller = "crfContaContabil";

export interface ICrfContaContabilAgrupador {
    contaContabilId: string;
    codigo: number;
    descricao: string;
    codigoAgrupador: string;
    acronimoAgrupadorId: string;
    disciplinaAgrupadorId: string;
    tipoAgrupadorTipoId: string;
}

export interface IUpdateCrfContaContabil {
    contaContabilId: string;
    acronimoAgrupadorId?: string;
    removeAcronimoAgrupador?: boolean;
}


export const getAllCrfContaContabil = () =>
    api.get<ICrfContaContabilAgrupador[]>(`${controller}`);

export const updateCrfContaContabil = (model: IUpdateCrfContaContabil) =>
    api.put(`${controller}/${model.contaContabilId}`, model);